import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import { Rocket, Target, Users } from 'lucide-react';
export default function AboutUS() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[600px] h-[600px] bg-primary-50 rounded-full blur-3xl opacity-50" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tight">We're on a mission to <br /><span className="text-primary-600">Make CPG Sizzle for Everyone</span></h1>;
    t2 = <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-10">Sizzle is the ultimate discovery platform for food and beverage enthusiasts. We're building the window into America's most exciting CPG brands.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="relative pt-32 pb-20 overflow-hidden">{t0}<div className="container mx-auto px-6 relative z-10 text-center">{t1}{t2}<div className="flex justify-center gap-4"><div className="px-6 py-3 bg-gray-50 border border-gray-100 rounded-2xl"><span className="text-sm font-semibold text-gray-700">A Sizzle CPG Labs project</span></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-shadow"><div className="w-14 h-14 bg-primary-100 rounded-2xl flex items-center justify-center text-primary-600 mb-8"><Target className="w-8 h-8" /></div><h3 className="text-2xl font-bold text-gray-900 mb-4">Discovery Focused</h3><p className="text-gray-600 leading-relaxed">We believe the best products often stay hidden. Our mission is to shine a light on the innovators and artisans defining the future of American pantries.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-shadow"><div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 mb-8"><Users className="w-8 h-8" /></div><h3 className="text-2xl font-bold text-gray-900 mb-4">Community Driven</h3><p className="text-gray-600 leading-relaxed">Collections and sharing are at our core. Sizzle is built for those who love to share their latest finds and discover what others are obsessing over.</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="py-24 bg-gray-50"><div className="container mx-auto px-6"><div className="grid grid-cols-1 md:grid-cols-3 gap-12">{t4}{t5}<div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-gray-100 hover:shadow-xl transition-shadow"><div className="w-14 h-14 bg-purple-100 rounded-2xl flex items-center justify-center text-purple-600 mb-8"><Rocket className="w-8 h-8" /></div><h3 className="text-2xl font-bold text-gray-900 mb-4">Future of CPG</h3><p className="text-gray-600 leading-relaxed">By bridging the gap between brands and enthusiasts, we're creating a more connected, transparent, and exciting CPG ecosystem.</p></div></div></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="text-4xl font-black text-gray-900 mb-8">The Story of Sizzle</h2>;
    t8 = <p className="text-lg text-gray-600 mb-6 leading-relaxed">Sizzle started as an experiment at CPG Labs. We saw a gap in how people discover new food and beverage products. While there were plenty of reviews and recipes, there wasn't a dedicated space to simply explore the vibrant landscape of local and emerging CPG brands.</p>;
    t9 = <p className="text-lg text-gray-600 mb-6 leading-relaxed">We built Sizzle to be that space. A place where discovery is effortless, visually engaging, and highly personal. Whether you're looking for the next big craft soda, a revolutionary plant-based snack, or just some inspiration for your next grocery run, Sizzle is here to help you find it.</p>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <section className="py-24"><div className="container mx-auto px-6"><div className="max-w-4xl mx-auto"><div className="prose prose-xl prose-gray">{t7}{t8}{t9}<div className="my-16 p-12 bg-primary-600 rounded-[3rem] text-white"><h3 className="text-3xl font-black mb-4">"The CPG product landscape is exploding with creativity. We're just here to hand you the binoculars."</h3><p className="text-primary-100 font-bold">— The Sizzle Team</p></div></div></div></div></section>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="min-h-screen bg-white">{t3}{t6}{t10}<section className="py-24 px-6 bg-gray-50"><div className="container mx-auto"><div className="bg-white rounded-[3rem] p-12 md:p-24 text-center relative overflow-hidden shadow-xl border border-gray-100"><h2 className="text-4xl font-black text-gray-900 mb-8 relative z-10">Join the discovery revolution</h2><Link href="/" className="px-12 py-6 bg-primary-600 text-white font-black text-xl rounded-2xl shadow-xl shadow-primary-200 hover:bg-primary-700 hover:scale-105 transition-all inline-block relative z-10 cursor-pointer">Start Exploring</Link></div></div></section></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}